import { NavLink } from "react-router-dom"
import SidebarMenuAdmin from "./SidebarMenuAdmin"

function MenuSuperAdmin() {
  return (
    <>
      <SidebarMenuAdmin />
      <li className="nav-item">
        <NavLink to="/display/gestion" className="nav-link">
          <i className="nav-icon fas fa-map-marker-alt" />
          <p>Emplacements</p>
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink to="/totem/validation" className="nav-link">
          <i className="nav-icon fas fa-check" />
          <p>Installation d'un player</p>
        </NavLink>
      </li>
    </>
  )
}

export default MenuSuperAdmin
